// DOM content loaded event listener
document.addEventListener('DOMContentLoaded', function() {

  
});
